import { Component } from '@theme/component';
import { sectionRenderer, morphSection } from '@theme/section-renderer';
import { Wishlist } from '@theme/wishlist';
// Product cards injected here arrive via morphSection(), and <script> tags
// inserted through DOM morphing never execute — so wishlist-button's own
// per-card script tag never registers the custom element on this page.
// Importing it as a module dependency (rather than relying on a separate
// <script> tag's load timing) guarantees it's registered before this file's
// own top-level code runs, regardless of network/parse order.
import '@theme/wishlist-button';

class WishlistSection extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(Wishlist.EVENT_NAME, this.onWishlistUpdate);
    this.#load();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(Wishlist.EVENT_NAME, this.onWishlistUpdate);
  }

  onWishlistUpdate = () => {
    this.#load();
  };

  async #load() {
    const { sectionId, searchUrl } = this.dataset;
    if (!sectionId || !searchUrl) return;

    const products = Wishlist.getProducts();

    if (products.length === 0) {
      this.#renderEmpty();
      return;
    }

    try {
      const url = new URL(searchUrl, location.origin);
      url.searchParams.set('q', products.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));
      url.searchParams.set('resources[type]', 'product');

      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);

      if (!html?.trim().length) {
        this.#renderEmpty();
        return;
      }

      morphSection(sectionId, html, { mode: 'hydration', injectStylesheet: true });
    } catch (error) {
      console.error('Wishlist section error:', error);
    }
  }

  #renderEmpty() {
    const grid = this.querySelector('[data-wishlist-grid]');
    const empty = this.querySelector('[data-wishlist-empty]');
    if (grid instanceof HTMLElement) grid.style.display = 'none';
    if (empty instanceof HTMLElement) empty.style.display = '';
  }
}

if (!customElements.get('wishlist-section')) {
  customElements.define('wishlist-section', WishlistSection);
}
